var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rating-stars inline-flex"},_vm._l((5),function(i){return _c('q-icon',{key:i,class:{ 'mr-2': i < 5},attrs:{"name":"star"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }